import { post } from '..';
import { TemplateType } from '../../constants/Types';
import { UpdateAssetBody } from './UpdateAsset';

interface AssetDetails extends UpdateAssetBody {
  type?: TemplateType,
  templateId: string,
  buildingId: string,
}

export interface AddAssetProps extends AssetDetails {
  assetId: string,
}

const createAsset = ({
  assetId, type = TemplateType.ASSET, locationId, templateId, buildingId, name, customFields, model,
  serial, manufacturer, description, labels,
}: AddAssetProps) => {
  const body: AddAssetProps = {
    assetId,
    type,
    locationId,
    templateId,
    buildingId,
    name,
    description,
    manufacturer,
    model,
    serial,
    customFields,
  };
  if (labels) body.labels = labels;

  return post('assets/v2', body);
};

export default createAsset;
